import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchApi } from '@/api/http'
import { forceRelogin, isOnLoginPageForRole } from '@/utils/authFlow'
import { clearPlatformToken } from '@/utils/platformAdminAuth'

const MSG_EXPIRED = {
  admin: 'Sessão de administrador expirada. Faça login novamente.',
  profissional: 'Sessão do profissional expirada. Faça login novamente.',
} as const

const SESSION_PATH = {
  admin: '/api/admin/session',
  profissional: '/api/profissional/session',
} as const

function roleFromPath(pathname: string): keyof typeof MSG_EXPIRED | null {
  if (pathname.startsWith('/admin/')) return 'admin'
  if (pathname.startsWith('/profissional/')) return 'profissional'
  return null
}

/**
 * Valida sessão no servidor (cookie httpOnly) ao entrar e de minuto a minuto.
 */
export function useSessionExpiryWatch(): void {
  const { pathname } = useLocation()

  useEffect(() => {
    const role = roleFromPath(pathname)
    if (!role || isOnLoginPageForRole(role)) return

    const check = async () => {
      try {
        const res = await fetchApi(SESSION_PATH[role])
        if (!res.ok) {
          forceRelogin(role, MSG_EXPIRED[role])
        }
      } catch {
        /* rede indisponível — não forçar logout */
      }
    }

    void check()
    const id = window.setInterval(() => void check(), 60_000)
    return () => window.clearInterval(id)
  }, [pathname])
}

/** Valida sessão da plataforma no servidor. */
export function usePlatformSessionWatch(active: boolean): void {
  useEffect(() => {
    if (!active) return
    const check = async () => {
      try {
        const res = await fetchApi('/api/platform/ping')
        if (!res.ok) {
          clearPlatformToken()
          window.location.replace('/platform/login')
        }
      } catch {
        /* ignore */
      }
    }
    void check()
    const id = window.setInterval(() => void check(), 60_000)
    return () => window.clearInterval(id)
  }, [active])
}
